import React, { PropsWithChildren } from "react";
import classNames from "./reports.module.css";


export const Literal = (props: PropsWithChildren) => (
	<span className={classNames.literal}>{props.children}</span>
)

export const SearchDetailsDeferRenderUntilOpenedContext = React.createContext<boolean>(false);

export const SearchDetailsRenderOnFirstExpand = ({children, deferredRenderOnExpand}: React.PropsWithChildren<{deferredRenderOnExpand?: () => React.JSX.Element}>) => {
	const deferRenderUntilOpen = React.useContext(SearchDetailsDeferRenderUntilOpenedContext);
	const [deferRender, setDeferRender] = React.useState(deferRenderUntilOpen);
	const onToggle: React.ToggleEventHandler<HTMLDetailsElement> = () => { setDeferRender(false) }
	return (
		<details className={classNames.searchDetails} onToggle={onToggle} >{
			children
		}{ (deferRender || deferredRenderOnExpand == null) ? null : 
			deferredRenderOnExpand()
		}</details>
	)
}
